export enum AlertTypeEnum {
        WelcomeScript = 45,
        GeneralMessages = 46,
        SpecialMessages = 47,
        NoResponsePlan = 48,
}
